import {ArtfactKind, EnvironmentKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import * as aws from 'aws-sdk';
import {Observable, Observer, Subject} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';

@HookClass('aws.sqs')
export class AwsSqsHook extends BaseHook {

    @Hook('bb8bb775-aba6-46fe-8c62-0b6a1d0580ce')
    public createQueue(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sqs = new aws.SQS({
                    region: 'us-east-1',
                    apiVersion: '2012-11-05',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });


                const envPrefix = settings.environment == EnvironmentKind.DEV ? 'develop' : 'production';

                const params = {
                    QueueName: `nick-${envPrefix}-${inputArtifact.object.config.name}-sqs`,
                    Attributes: {
                        'VisibilityTimeout': '3600',
                        'MessageRetentionPeriod': '86400'
                    }
                };

                return new Observable((observer: Observer<any>) => {

                    sqs.createQueue(params, (err, data) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const uploadArtifact = new NickProcessArtfact();
                            uploadArtifact.kind = ArtfactKind.ANY;
                            uploadArtifact.object = data;
                            observer.next(uploadArtifact);
                        }

                        observer.complete();
                    });
                });
            }));
    }

    @Hook('542b0393-899b-4062-8114-1257d33791d9')
    public receiveMessage(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const result$ = new Subject<any>();

        this.settings
            .pipe(map((settings) => {

                const sqs = new aws.SQS({
                    region: 'us-east-1',
                    apiVersion: '2012-11-05',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });


                const params = {
                    AttributeNames: [
                        'nick-system',
                        'nick-authorization',
                        'nick-controller',
                        'nick-method'
                    ],
                    MaxNumberOfMessages: inputArtifact.object.config.messageCount,
                    MessageAttributeNames: [
                        'All'
                    ],
                    QueueUrl: inputArtifact.object.config.queueUrl,
                    VisibilityTimeout: 3600,
                    WaitTimeSeconds: 0
                };

                sqs.receiveMessage(params, (err, data) => {
                    if (err) {
                        //
                    } else {
                        const uploadArtifact = new NickProcessArtfact();
                        uploadArtifact.kind = ArtfactKind.ANY;
                        uploadArtifact.object = data;
                        result$.next(uploadArtifact);
                    }

                });
            })).subscribe();

        return result$;
    }

    @Hook('cc561628-2358-4b90-80d2-9d2888310442')
    public deleteMessage(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sqs = new aws.SQS({
                    region: 'us-east-1',
                    apiVersion: '2012-11-05',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                const params = {
                    QueueUrl: inputArtifact.object.config.queueUrl,
                    ReceiptHandle: inputArtifact.object.config.receiptHandle
                };

                return new Observable((observer: Observer<any>) => {
                    sqs.deleteMessage(params, (err, data) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const uploadArtifact = new NickProcessArtfact();
                            uploadArtifact.kind = ArtfactKind.ANY;
                            uploadArtifact.object = data;
                            observer.next(uploadArtifact);
                        }

                        observer.complete();
                    });
                });
            }));
    }

    @Hook('7bb19a0a-93b8-41a0-b151-648054ac98ce')
    public sendMessage(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sqs = new aws.SQS({
                    region: 'us-east-1',
                    apiVersion: '2012-11-05',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                const params = {
                    MessageAttributes: {
                        'nick-system': {
                            DataType: 'String',
                            StringValue: inputArtifact.object.config.attributes.systemId
                        },
                        'nick-authorization': {
                            DataType: 'String',
                            StringValue: inputArtifact.object.config.attributes.authorization
                        },
                        'nick-controller': {
                            DataType: 'String',
                            StringValue: inputArtifact.object.config.attributes.controller
                        },
                        'nick-method': {
                            DataType: 'String',
                            StringValue: inputArtifact.object.config.attributes.method
                        }
                    },
                    MessageBody: inputArtifact.object.data,
                    QueueUrl: inputArtifact.object.config.queueUrl
                };

                return new Observable((observer: Observer<any>) => {
                    sqs.sendMessage(params, (err, data) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const uploadArtifact = new NickProcessArtfact();
                            uploadArtifact.kind = ArtfactKind.ANY;
                            uploadArtifact.object = data;
                            observer.next(uploadArtifact);
                        }

                        observer.complete();
                    });
                });
            }));
    }

}
